import {
  PASSPORT_NAME_FIRST_NAME,
  PASSPORT_NAME_LAST_NAME,
  USER_EMAIL,
} from '../constants/fieldNamesConstants';

const maskSubmittedParams = objectToObscure => {
  if (!objectToObscure) return objectToObscure;
  const obscurityKeyConfig = [PASSPORT_NAME_FIRST_NAME, PASSPORT_NAME_LAST_NAME, USER_EMAIL];
  const obscuredObject = objectToObscure;
  Object.keys(objectToObscure).forEach(key => {
    if (obscurityKeyConfig.includes(key)) {
      if (objectToObscure[key].length <= 1) return;
      const keyToObscure = key;
      const valueToObscure = objectToObscure[key];
      const censored =
        valueToObscure[0] + '*'.repeat(valueToObscure.length - 2) + valueToObscure.slice(-1);
      obscuredObject[keyToObscure] = censored;
    }
    if (typeof objectToObscure[key] === 'object') {
      maskSubmittedParams(objectToObscure[key]);
    }
  });

  return obscuredObject;
};

export default maskSubmittedParams;
